import { BaseFieldRenderer } from './base-field-renderer';
import { EmailFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class EmailFieldRenderer extends BaseFieldRenderer<EmailFieldJsonData> {
    protected override get defaultData(): EmailFieldJsonData {
        return {
            id: '',
            type: 'email',
            label: TranslateUtils.EMAIL_FIELD.LABEL,
            placeholder: TranslateUtils.EMAIL_FIELD.PLACEHOLDER,
            required: false,
            hiddenLabel: false,
            crmFieldData: {
                mixedType: 'ContactField',
                type: 'Email',
                systemName: 'Email',
                name: 'Email'
            }
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: EmailFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input', 'default');
        input.type = 'email';
        input.maxLength = 254;

        this.applyCommonAttributes(input, fieldJsonData);

        return input;
    }
}
